import React from "react";
import "../MatchingProducts/styles.scss";
import ProductCard from "Components/Productcard";
import AdvancedLink from "Components/AdvancedLink";
import ProductSlider from "Components/ProductSlider";
import { useWindowSize } from "Utilities";

const OthersWatchedProducts = ({ othersWatchedProduct }) => {
  const [width] = useWindowSize();

  const hasAnyReview =
    othersWatchedProduct?.products?.length &&
    othersWatchedProduct?.products?.some((product) => product?.review_status == "1");

  return (
    <>
      {width > 1280 && othersWatchedProduct?.products?.length ? (
        <div className="otherWatched__product pt-xl-12 w-1/1">
          <div className="title-section">
            <h2>Anderen bekeken ook</h2>
            {othersWatchedProduct?.url_key ? (
              <AdvancedLink
                className="fw-300"
                to={othersWatchedProduct?.url_key}
                state={{
                  currentPageView: othersWatchedProduct?.plp_design_view,
                }}
              >
                <div className="divider">{`Bekijk alles >`}</div>
              </AdvancedLink>
            ) : (
              ""
            )}
          </div>
          <div className="flex wrap gap-x-4 gap-y-4 gap-4-14 xl-gap-x-8 xl-gap-y-16 pb-3">
            {othersWatchedProduct?.products?.map((item, index) => (
              <React.Fragment key={`watchedproductGrid${index}`}>
                <ProductCard data={item} key={`product__watched_${index}`} related={true} hasAnyReview={hasAnyReview} />
              </React.Fragment>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}

      {width < 1280 && othersWatchedProduct?.products?.length ? (
        <div className="otherWatched__product">
          <ProductSlider
            title="Anderen bekeken ook"
            data={othersWatchedProduct?.products}
            pageName="pdp"
            showAllLastCard={othersWatchedProduct?.url_key ? true : false}
            toGo={othersWatchedProduct?.url_key}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default OthersWatchedProducts;
